module.exports = __webpack_public_path__ + "static/img/1_1_3.44bee4a8.jpg";